import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Stack, Typography } from '@mui/material';

/**
 * Encabezado de sección con acento de color e icono.
 */
export function FormSectionHeader({ accentColor = 'primary', icon: Icon, title, description, sx = {} }) {
    const theme = useTheme();
    const accent = theme.palette[accentColor] || theme.palette.primary;

    return (
        <Stack
            direction="row"
            spacing={1.5}
            sx={{
                alignItems: 'flex-start',
                mb: 2,
                pl: 1.5,
                borderLeft: `4px solid ${accent.main}`,
                ...sx,
            }}
        >
            {Icon ? (
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        bgcolor: alpha(accent.main, 0.14),
                        color: accent.main,
                    }}
                >
                    <Icon fontSize="small" />
                </Box>
            ) : null}
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                    {title}
                </Typography>
                {description ? (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {description}
                    </Typography>
                ) : null}
            </Box>
        </Stack>
    );
}

/**
 * Bloque de sección con franja de acento y encabezado.
 */
export function FormSectionBlock({ accentColor = 'primary', icon: Icon, title, description, children, sx = {} }) {
    const theme = useTheme();
    const accent = theme.palette[accentColor] || theme.palette.primary;

    return (
        <Box
            sx={{
                mb: 3,
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                overflow: 'hidden',
                backgroundColor: theme.palette.background.paper,
                ...sx,
            }}
        >
            <Box
                sx={{
                    height: 4,
                    background: `linear-gradient(90deg, ${accent.main} 0%, ${alpha(accent.main, 0.35)} 100%)`,
                }}
            />
            <Box sx={{ p: { xs: 2, sm: 2.5 } }}>
                <FormSectionHeader
                    accentColor={accentColor}
                    icon={Icon}
                    title={title}
                    description={description}
                    sx={{ borderLeft: 'none', pl: 0 }}
                />
                {children}
            </Box>
        </Box>
    );
}
